var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QDatetimeMod',_vm._g(_vm._b({staticClass:"select-ref-date",attrs:{"value":_vm.timestamp,"format":"YYYY年M月D日(ddd)","format-model":"number"}},'QDatetimeMod',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }